import {Link} from 'react-router-dom'
import {AiFillStar} from 'react-icons/ai'
import {BiMap} from 'react-icons/bi'
import {FaSuitcase} from 'react-icons/fa'
import './index.css'

const JobItem = props => {
  const {eachJob} = props

  const {
    companyLogoUrl,
    title,
    rating,
    location,
    employmentType,
    packagePerAnnum,
    jobDescription,
    id,
  } = eachJob

  return (
    <li>
      <Link to={`/jobs/${id}`} className="link-container">
        <div className="job-item-container">
          <div className="job-icon-container">
            <img
              src={companyLogoUrl}
              alt="company logo"
              className="company-logo"
            />
            <div>
              <p className="job-title">{title}</p>
              <span className="star-container">
                <AiFillStar color="#fbbf24" size="20" />
                <p className="rating-para">{rating}</p>
              </span>
            </div>
          </div>
          <div className="package-container">
            <div className="locate-job-container">
              <div className="locate-container">
                <BiMap color="#ffffff" size="20" />
                <p className="job-locate-para">{location}</p>
              </div>

              <div className="job-type-container">
                <FaSuitcase color="#ffffff" size="20" />
                <p className="job-type-para">{employmentType}</p>
              </div>
            </div>
            <h1 className="package-head">{packagePerAnnum}</h1>
          </div>
          <hr className="job-hr-line" />

          <h1 className="description-head">Description</h1>
          <p className="description-para">{jobDescription}</p>
        </div>
      </Link>
    </li>
  )
}

export default JobItem
